import Axios from "axios";
import { SET_PROPOSAL_STATUS_ROUTES_LIST, UNSET_PROPOSAL_STATUS_ROUTES_LIST } from "@/store/mutation-types";
import { getSalesProposalStatus } from "@/store/api";

// initial state
const state = {
    getSalesProposalStatus: [],
};

const getters = {
    getSalesProposalStatus(state) {
        return state.getSalesProposalStatus;
    },
};

const mutations = {
    [SET_PROPOSAL_STATUS_ROUTES_LIST](state, data) {
        state.getSalesProposalStatus = data;
    },
    [UNSET_PROPOSAL_STATUS_ROUTES_LIST](state) {
        state.getSalesProposalStatus = [];
    },
};

const actions = {
    getSalesProposalStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesProposalStatus, data)
                .then(function (response) {
                    commit("SET_PROPOSAL_STATUS_ROUTES_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_PROPOSAL_STATUS_ROUTES_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },

    getSalesProposalStatusById({ commit }, data) {
        const getSalesProposalStatusById = `${getSalesProposalStatus}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSalesProposalStatusById)
                .then((response) => {
                    resolve(response.data.code);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};